interface CreateAdditionalBasketPayload {
  shop_id: number
  party_id: number
  name: string
}

export class CreateAdditionalBasketRequest {
  endpointUrl: URL
  data: CreateAdditionalBasketPayload
  method = 'POST' as const
  headers: HeadersInit = { 'Content-Type': 'application/json' }

  constructor(endpoint: string, partyId: number, shopId: number, name: string) {
    this.endpointUrl = new URL(endpoint + 'CreateAdditionalBasket/', window.location.href)
    this.data = {
      shop_id: shopId,
      party_id: partyId,
      name: name,
    }
  }
}
